module.exports = __webpack_public_path__ + "static/media/valor_cuota_white_16px.4aba4561.svg";